

exports.__esModule = true;
exports.isValidAmount = isValidAmount;
exports.isNumber = isNumber;
exports.isValidQuantity = isValidQuantity;
exports.isValidTaxRate = isValidTaxRate;
exports.isValidDiscountRate = isValidDiscountRate;
exports.isWeightValid = isWeightValid;
// Is the given object a valid amount?
// TODO/mm similar to: is_valid_discount_param() - refactor?
function isValidAmount(input) {
    return isNumber(input) && +input >= 0;
}

// Is the input a valid shipping amount? Note: Individual negative shipping values are valid too.
function isNumber(input) {
    return input !== undefined && $.isNumeric(input);
}

// Is input a value quantity parameter value?
// Has to be a positive integer.
function isValidQuantity(input) {
    if (isNaN(input) || +input <= 0 || !Number.isInteger(+input)) {
        return false;
    }
    return true;
}

// Is the given value a valid WPS tax rate?
// WPS Bummer: tax over 100 in theory should be ok, but doc and legacy says caps at 100.
// Weird: has to be from 0.001 through 100, inclusive, or exactly zero.
// This is due to:
// - no tax field in Symphony cart means use merchants profile tax rate.
// - tax of zero in Symphony cart means really use no tax, and don't use profile tax rate.
function isValidTaxRate(input) {
    return input !== undefined && isNaN(input) === false && (+input >= 0.001 && +input <= 100 || +input === 0);
}

// Is the given value a valid WPS discount rate?
// "Less than 100" says the WPS docs. I'm adding also: non-negative.
function isValidDiscountRate(input) {
    return input !== undefined && isNaN(input) === false && +input >= 0 && +input <= 100;
}

function isWeightValid(value) {
    return value !== undefined && isNaN(value) === false && value >= 0;
}


//////////////////
// WEBPACK FOOTER
// ./pages/xo-shoppingcart/validators.js
// module id = ./pages/xo-shoppingcart/validators.js
// module chunks = 1